import React from "react";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import * as postsActions from "../../../store/admin";

import * as _ from "lodash";

class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input_group_search: "",
    };
  }

  componentDidMount() {}

  /**
   * find group id in list of groups
   * @param {*} id
   */
  checkGroupId(id) {
    let obj = _.find(this.props.selectedGroupList, {
      groupUid: id,
    });
    if (obj) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs in state and props
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps) {}

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {}

  /**
   * Filter groups on search in input box
   * @param {*} group
   * @param {*} e
   */

  onFilterGroupInputSearch(group, e) {
    e.preventDefault();
    const { value } = e.target;
    this.setState({
      input_group_search: {
        group: group,
        keyword: value,
      },
    });
  }

  render() {
    const { groups } = this.props;
    let grupBy = _.groupBy(groups, "grouptype");
    if (this.state.input_group_search) {
      let keyword = this.state.input_group_search.keyword;
      if (keyword) {
        let filg = _.filter(
          grupBy[this.state.input_group_search.group],
          function (o) {
            let match = o.groupname.match(new RegExp(keyword, "gi"));
            return match && match.length > 0;
          }
        );
        grupBy[this.state.input_group_search.group] = filg;
      }
    }

    const groupBy = grupBy;
    return (
      <div>
        <div className="accordion" id="accordionExample">
          {groups &&
            Object.keys(groupBy).map((item, index) => (
              <div key={item} className="card">
                <div className="card-header" id="headingOne">
                  <a
                    className="btn btn-link"
                    data-toggle="collapse"
                    data-target={`#group-type-${index}`}
                    aria-expanded="false"
                    aria-controls={item}
                  >
                    <h2 className="mb-0">{item}</h2>
                  </a>
                </div>
                <div
                  id={`group-type-${index}`}
                  className="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div className="card-body">
                    <div className="filt d-flex justify-content-between align-items-center">
                      <input
                        type="text"
                        name="inputfilter"
                        onChange={this.onFilterGroupInputSearch.bind(
                          this,
                          item
                        )}
                      ></input>
                      <i className="fa fa-filter" aria-hidden="true"></i>
                    </div>
                    {groupBy &&
                      groupBy[item].map((subitem, index) => (
                        <label key={subitem.groupUid} className="typecheck">
                          {subitem.groupname}
                          <input
                            type="checkbox"
                            checked={this.checkGroupId(subitem.groupUid)}
                            onChange={(e) => this.props.onGroupsChange(e)}
                            value={subitem.groupUid}
                          />
                          <span className="typemark"></span>
                        </label>
                      ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  return {
    token: state.user.cognito_data.token,
    user: state.user.user,
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(postsActions, dispatch)
)(Groups);
